<template>
    <v-dialog v-model="dialog" max-width="80%" @keydown.esc="cancel">
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.reseller.fixCategory.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>{{ $t('actions.reseller.fixCategory.p1') }}</p>
                <p>{{ $t('actions.reseller.fixCategory.p2') }}</p>
                <p>{{ $t('actions.reseller.fixCategory.p3') }}</p>
                <p v-if="reseller">
                    <strong>Parceiro: {{ reseller.trade_name }}</strong>
                </p>
                <v-select
                    v-model="selectedCategory"
                    autofocus
                    :items="categoryOptions"
                    item-text="name"
                    item-value="id"
                    :label="$tc('resources.category.name', 1)"
                    return-object
                    :loading="loading || sorting"
                    clearable
                ></v-select>
                <v-card-text
                    v-if="selectedCategory && selectedCategory.id !== null"
                    class="text-center"
                    elevation="2"
                >
                    <CategoryBadge :category="selectedCategory" />
                    <strong v-if="reseller.billable">
                        {{ selectedCategory.discount_percentage }}% Desonto na
                        Fatura
                    </strong>
                    <strong v-else
                        >{{ selectedCategory.percent }}% de Comissão</strong
                    >
                </v-card-text>
                <p>{{ $t('actions.reseller.fixCategory.p4') }}</p>
            </v-card-text>
            <v-card-actions>
                <v-btn class="col" text @click="dialog = false">
                    {{ $t('actions.reseller.fixCategory.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="save"
                    :loading="saving"
                >
                    {{ $t('actions.reseller.fixCategory.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Category from '@/models/Category'
import CategoryBadge from '@/shared/components/CategoryBadge'

export default {
    components: {
        CategoryBadge,
    },

    data: () => {
        return {
            dialog: false,
            reseller: undefined,
            categories: [],
            selectedCategory: undefined,
            loading: true,
            sorting: true,
            saving: false,
        }
    },

    watch: {
        dialog() {
            if (this.dialog === false) {
                this.reseller = undefined
                this.selectedCategory = undefined
            }
        },
    },

    computed: {
        categoryOptions() {
            let categories = this.categories.map(c =>
                c && typeof c.clone === 'function'
                    ? c.clone().data()
                    : _.cloneDeep(c).data(),
            )
            let nullCategory = new Category()
            nullCategory.name = 'Sem categoria fixa'
            nullCategory.id = null

            categories.unshift(nullCategory)

            if (this.reseller && this.reseller.has_fixed_category) {
                let current = JSON.parse(JSON.stringify(this.reseller.category))
                current.name += ' (ATUAL)'
                categories.unshift(current)
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.selectedCategory = current
            } else {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.selectedCategory = nullCategory
            }

            return categories
        },
    },

    methods: {
        open(reseller) {
            this.dialog = true
            this.reseller = reseller
            this.sortCategories()
        },

        async loadCategories() {
            let perPage = 50
            let page = 1
            let lastPage = 1

            for (page; page <= lastPage; page++) {
                let res = await new Category().paginate(perPage, page)
                lastPage = res.meta.pagination.total_pages

                res.data.forEach(category => this.categories.push(category))
            }

            this.loading = false
        },

        sortCategories() {
            this.sorting = true
            let sortBy = this.reseller.billable
                ? 'discount_percentage'
                : 'percent'
            this.categories.sort((a, b) => {
                if (a[sortBy] == b[sortBy]) return 0
                if (a[sortBy] > b[sortBy]) return 1
                return -1
            })
            this.sorting = false
        },

        async save() {
            this.saving = true
            let res = await this.reseller.fixCategory(
                this.selectedCategory ? this.selectedCategory.id : null,
            )
            this.saving = false
            this.dialog = false

            if (!res) return

            this.$emit('modelChanged', this.reseller)
            this.$bus.$emit(
                'notify',
                'warning',
                this.$t('actions.reseller.fixCategory.success'),
            )
        },
    },

    created() {
        this.loadCategories()
    },
}
</script>

<style></style>
